import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TenantDriverDto } from '../../drivers/dtos/tenant-driver.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { CustomerStatusEnum } from '../enums/customer-status.enum';
import { CustomerTypeEnum } from '../enums/customer-type.enum';

/**
 * Customer DTO for lists
 */
@CaslSubject(AppSubjectEnum.CUSTOMER)
export class CustomerListDto extends BaseDto {
  code!: string;
  type!: CustomerTypeEnum;
  status!: CustomerStatusEnum;
  contact!: TenantContactDto;
  driver?: TenantDriverDto | null;
  tags?: TagListDto[] | null;
}
